import Colors from '@/utils/colors';

/** Overrides que valem nos dois temas. O ciano marca o produto Garantias: aba ativa e link. */
export const globalTheme = {
	Tabs: {
		barColor: Colors.info,
		tabTextColorActiveLine: Colors.info,
		tabTextColorHoverLine: Colors.info,
		tabTextColorActiveBar: Colors.info,
		tabTextColorHoverBar: Colors.info,
	},
};
